// extracted by mini-css-extract-plugin
export default {"header":"style_header__0-tPa","title":"style_title__WW7j-","deleteButton":"style_deleteButton__15DZw"};